import React from 'react';
import T from 'prop-types';

import RadioButtonGroup from '../../../RadioButtonGroup';

const options = [
  {
    id: 'on',
    value: true,
    text: 'Backtesting',
    subElement: (
      <>
        <p className="paragraph-md">Includes app or publisher data only for the period they belong to the company.</p>
        <p className="service-info-text">Only available as CSV when “Show data for every app” is chosen under Entity Granularity (below).</p>
      </>),
  },
  {
    id: 'off',
    value: false,
    text: 'Pro-Forma Analysis',
    subElement: (
      <>
        <p className="paragraph-md">Treats the company’s present lineup of apps and publishers as if it had been in place for the entire selected date range.</p>
        <p className="service-info-text">Only available as CSV when “Aggregate data to company/publisher” is chosen under Entity Granularity (below).</p>
      </>
    ),
  },
];

const ExportDataUse = ({
  active,
  onChange,
}) => (
  <section className="export-settings-section">
    <div className="export-settings-section__about">
      <h4 className="h5 export-settings-section__title">Export Data Use</h4>
      <p className="paragraph-md export-settings-section__description">Determines if acquisition timelines are referenced to ensure performance data is only reported for the period the entity is owned by the parent company.</p>
    </div>
    <div className="export-settings-section__content">
      <RadioButtonGroup
        active={active}
        options={options}
        name="export-data-use"
        className="export-settings-section__options export-data-use-options"
        enabled
        onChange={onChange}
      />
    </div>
  </section>
);

ExportDataUse.propTypes = {
  active: T.bool.isRequired,
  onChange: T.func.isRequired,
};

export default ExportDataUse;
